<template>
  <div class="container-list">
    <div class="common-page common-head">
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
            </div> -->
    </div>
    <div class="flex">
      <div class="flex1">
        <div
          class="common-page common-tool-bar"
          style="justify-content: space-between"
        >
          <!-- <div>
            <el-button size="small" @click="open()" type="primary" plain
              >导出文件</el-button
            >
            <el-button
              class="ml10"
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="showDia = true"
              >查询</el-button
            >
          </div> -->
        </div>
        <div class="common-page common-list">
          <el-table :data="list" class="">
            <el-table-column prop="c_type" align="center" label="单位类型">
              <template slot-scope="scope">
                {{ $map.unitType[scope.row.c_type] }}
              </template>
            </el-table-column>
            <el-table-column prop="c_name" label="单位名称" align="center">
            </el-table-column>

            <el-table-column prop="device_code" label="设备编号" align="center">
            </el-table-column>
            <el-table-column prop="c_address" align="center" label="地址">
            </el-table-column>
            <el-table-column prop="user_name" align="center" label="查岗人员">
            </el-table-column>
            <el-table-column prop="c_phone" align="center" label="联系电话">
            </el-table-column>
            <el-table-column prop="sendtime" align="center" label="查岗时间">
            </el-table-column>

            <el-table-column prop="backtime" align="center" label="应答时间">
            </el-table-column>
            <el-table-column prop="states" align="center" label="结果">
              <template slot-scope="scope">
                {{ $map.checkStatus[scope.row.states] }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <el-tree
             :data="data"
             :props="defaultProps"
              accordion
            @node-click="handleNodeClick">
</el-tree> -->
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="pageChange"
          :page-size="10"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <fm-generate-form
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      >
      </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="canclesub" size="small">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="请选择公司"
      :visible.sync="daomodle"
      :close-on-click-modal="false"
    >
      <el-form v-model="outform" style="min-height: 130px">
        <el-form-item label="单位名称">
          <el-select v-model="outform.c_company_num" filterable>
            <el-option
              v-for="item in shangjioption"
              :key="item.value"
              :label="item.key"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="center">
        <el-button type="primary" @click="output" size="small">导出</el-button>
        <el-button @click="cancleout" size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { getrecord } from "../../api/device";
// import { getMapByid } from "../../api/common";
export default {
  props: ["c_num"],
  data() {
    return {
      list: [],
      params: {
        page: 1,
        aftertime: "",
        beforetime: "",
        c_name: "",
        company_num: this.c_num,
      },
      total: 0,
      daomodle: false,
      shangjioption: [],
      outform: {
        c_company_num: "",
      },
      showDia: false,
      searchForm: this.$getForm("checkRecordSearch"),
      editData: {},
      remoteFuncs: {},
    };
  },
  created() {
    this.getList();
  },
  components: {},
  methods: {
    // changeStatus(id,status){
    //     switchCompany({id,status}).then(res=>{
    //         this.getList()
    //     }).catch(err=>{

    //     })
    // },
    cancleout() {
      this.outform.c_company_num = "";
      this.daomodle = false;
    },
    //导出
    output() {
      var url = `${this.$config.apiUrl}/queryjob/queryjobdownload?c_company_num=${this.outform.c_company_num}`;
      window.open(url, "_blank");
    },
    open() {
      (this.daomodle = true),
        this.$post("/devicemanage/selectconpanybyme").then((res) => {
          var arr = [];
          res.data.map((item) => {
            var obj = { key: item.c_name, value: item.c_company_num };
            arr.push(obj);
          });
          this.shangjioption = arr;
        });
    },
    canclesub() {
      this.showDia = false;
      this.params = {
        page: 1,
        aftertime: "",
        beforetime: "",
        c_name: "",
      };
      this.getList();
    },
    getList() {
      this.c_company_num = this.c_num;
      this.$post("/queryjob/queryjoblogs", this.params)
        .then((res) => {
          // console.log(res.data)x
          this.total = res.count;
          this.list = res.list;

          // console.log(this.list)
        })
        .catch((err) => {});
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          // var data = {...data,beforetime:data.startdate+' '+data.starttime,aftertime:data.enddate+' '+data.endtime}
          // console.log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          // console.log(data)
          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    getUnit() {},
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style scoped>
.btn {
  margin-left: 10px;
}
.common-head {
  border: none;
}
.common-page {
  padding: 0;
}
</style>
